var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTransit3Off(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 42,
    viewBox: "0 0 40 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31.5,
    cy: 33.5,
    r: 8.5,
    fill: "#9D9EB7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.7715 7.98145L32 8.09668V23.0117C31.8343 23.004 31.6676 23 31.5 23C30.8543 23 30.2228 23.0613 29.6094 23.1729V9.57812L16 2.69043L2.39062 9.57812V31.5947H6.2334V14.2422H25.7666V24.7041C22.8972 26.5783 21 29.817 21 33.5C21 33.6676 21.0049 33.8343 21.0127 34H0V8.09668L0.228516 7.98145L16 0L31.7715 7.98145ZM8.62402 24.9102H10.5459V28.0645H12.1035V24.9102H15.2207V31.5928H16.7793V24.9102H19.8965V28.0645H21.4541V24.9102H23.376V16.6475H19.8965V23.333H12.1035V16.6475H8.62402V24.9102ZM15.2207 19.584H16.7793V16.6475H15.2207V19.584ZM21.0908 12.46H10.9092V6.89941H21.0908V12.46ZM13.2988 10.0547H18.7012V9.30566H13.2988V10.0547Z",
    fill: "#9D9EB7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6289 29L37.2588 33.5L34.1289 33.5L34.1289 37L29.1289 37L29.1289 33.5L26 33.5L31.6289 29Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransit3Off);
export default __webpack_public_path__ + "static/media/transit3Off.b3c614524af2a44790527cb873248325.svg";
export { ForwardRef as ReactComponent };